// import Cookies from 'js-cookie';
import { ActionContext } from 'vuex';

import IState from '@/interfaces/IState';
// import getCookieDomain from '@/libs/domain/getCookieDomain';

export default (context: ActionContext<IState, IState>) => {
    // const token = Cookies.get('access_token', {
    //     domain: getCookieDomain()
    // });

    const token = localStorage.getItem('access_token');

    if (!token) {
        return;
    }
    context.dispatch('currentUser');
    context.commit('authUser', token);
};
